import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./UserFeedback.css";

const UserFeedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const feedbacksPerPage = 10;

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/user_feedback`)
      .then((response) => setFeedbacks(response.data))
      .catch((error) => console.error("Error fetching user feedback:", error));
  }, []);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const currentFeedbacks = feedbacks.slice(
    currentPage * feedbacksPerPage,
    (currentPage + 1) * feedbacksPerPage
  );

  return (
    <div className="user-feedback">
      <h2>User Feedback</h2>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Predicted Species</th>
            <th>Feedback Species</th>
            <th>User</th>
            <th>Confidence</th>
            <th>Time</th>
            <th>Image</th>
          </tr>
        </thead>
        <tbody>
          {currentFeedbacks.map((feedback) => (
            <tr key={feedback.id}>
              <td>{feedback.id}</td>
              <td>{feedback.predicted_species}</td>
              <td>{feedback.feedback_species}</td>
              <td>{feedback.user}</td>
              <td>{feedback.confidence}</td>
              <td>{new Date(feedback.time).toLocaleString()}</td>
              <td>
                <img
                  src={`${process.env.REACT_APP_API_URL}/static/identified_pics/${feedback.id}.jpg`}
                  alt="Identified Species"
                  width="50"
                  height="50"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        breakLabel={"..."}
        pageCount={Math.ceil(feedbacks.length / feedbacksPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
    </div>
  );
};

export default UserFeedback;
